import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import Counter from 'components/atoms/Counter';
import IconTodo from 'components/atoms/IconTodo';
import Image from 'components/atoms/Image';
import Link from 'components/atoms/Link';
import Bevel from 'components/helper/Bevel';

import routes from 'defs/routes';
import { DISPLAY_FORMATS, format } from 'helper/dateTime';
import i18n from 'helper/i18n';

import { IconTodoProps } from 'components/atoms/IconTodo';
import { ImageProps } from 'components/atoms/Image';

export type TodoType = {
	id: string;
} & IconTodoProps;

export type BoardStageProps = {
	title: string;
	todos: Array<TodoType>;
	image: ImageProps;
	currentDate: string;
};

type BoardStageTodosArgsType = {
	currentDate: string;
	todos: TodoType[];
};

type BordStageIntroArgsType = {
	title: string;
};

const countTodos = (todos) => todos.reduce((acc, cur) => acc + (cur.done ? 0 : 1), 0);

const renderPendingText = (todos, currentDate) => {
	const count = countTodos(todos);

	return (
		<div className="m-board-stage__pending">
			<span className="m-board-stage__pending-text">
				{i18n('react.impulsCoach.molecules.BoardStage.pending.before')}
			</span>
			<Counter count={count} />
			<span className="m-board-stage__pending-main">
				<strong>{i18n('react.impulsCoach.molecules.BoardStage.pending.main', {}, count)}</strong>
			</span>
			<span className="m-board-stage__pending-date">{format(currentDate, DISPLAY_FORMATS.SHORT_DATE)}</span>
		</div>
	);
};

const BoardStageIntro = ({ title }: BordStageIntroArgsType) => (
	<React.Fragment>
		<span className="m-board-stage__headline">{i18n('react.impulsCoach.molecules.BoardStage.deckhead')}</span>
		<h2 className="m-board-stage__title">{title}</h2>
	</React.Fragment>
);

const BoardStageTodos = ({ todos, currentDate }: BoardStageTodosArgsType) => (
	<RouterLink className="m-board-stage__todo-link" to={routes.today.indexRoute.href}>
		{todos.length > 0 ? renderPendingText(todos, currentDate) : null}
		<ul className="m-board-stage__todo-list">
			{todos.map((todo: TodoType) => (
				<li key={todo.id} className="m-board-stage__todo-item">
					<IconTodo {...todo} />
				</li>
			))}
		</ul>
	</RouterLink>
);

export const BoardStage = (props: BoardStageProps) => {
	return (
		<div className="m-board-stage">
			<div className="container container--full-width-ms">
				<div className="row">
					<div className="col-xs-12 visible-sm">
						<div className="m-board-stage__intro">
							<BoardStageIntro title={props.title} />
						</div>
					</div>

					<div className="col-xs-12 col-md-4 col-sm-4">
						<div className="m-board-stage__head">
							<div className="m-board-stage__image">
								<Image srcset={props.image.srcset} title={props.title} alt={props.image.alt} />
							</div>
							<div className="m-board-stage__phone-bg" />
						</div>
					</div>

					<div className="col-xs-12 col-md-8 col-sm-8">
						<div className="m-board-stage__figure">
							<div className="m-board-stage__intro hidden-sm">
								<BoardStageIntro title={props.title} />
							</div>
							<div className="m-board-stage__todo">
								<BoardStageTodos todos={props.todos} currentDate={props.currentDate} />
							</div>
							<div className="m-board-stage__link">
								<Link
									modifier="button"
									title={i18n('react.impulsCoach.molecules.BoardStage.continue')}
									href={routes.today.indexRoute.href}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Bevel modifier="bottom-left" color="007580" />
		</div>
	);
};

export default BoardStage;
